import React from "react";
import styled, { keyframes } from "styled-components";

const Rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
`;

const Container = styled.div<{ fill: string }>`
    position: relative;
    height: 33px;
    line-height: 33px;
    width: 22px;

    & .outer {
        animation: ${Rotate} 8s linear infinite;
        position: absolute;
        top: 6px;
        border: 1px dashed ${(p) => p.fill};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        border-radius: 50%;
    }

    & .inner {
        animation: ${Blink} 2s linear infinite;
        position: absolute;
        left: 5px;
        top: 11px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 10px solid ${(p) => p.fill};
    }
`;

export default function UploadProgress({ fill }: { fill: string }) {
    return (
        <Container fill={fill}>
            <div className="outer" />
            <div className="inner" />
        </Container>
    );
}
